import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../theme/Component/usePaginator";
import { useEffect } from "react";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { _PreparationHiringStageMapping, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectAdquisitionItemConstan } from "../../adquisition-setting/SelectAdquisitionItemConstan";

interface PreparationHiringStageMappingProps {
    IDHiringModalityStage: number;
    IDHiringModality: number;
}

export const PreparationHiringStageMapping = ({ IDHiringModalityStage, IDHiringModality }: PreparationHiringStageMappingProps) => {

    const { instance, bean, setBean, lista, setLista, addRequiredFields, validateForm, isRequired, isMissing } = useDataBean(_PreparationHiringStageMapping);

    const modal = useModal("", MODAL_md);
    const modalC = useModal("", MODAL_SM);
    const paginador = usePaginator();

    useEffect(() => {
        console.log(IDHiringModalityStage)
        if (IDHiringModalityStage) {
            getLista();
        }
        addRequiredFields(["PreparationState"]);
    }, [IDHiringModalityStage])

    const getLista = () => {
        const props = {
            IDHiringModalityStage: IDHiringModalityStage,
            IDHiringModality: IDHiringModality,
            State: 1,
        }
        instance.getPreparationHiringStageMappingCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDPreparationHiringStageMapping', visible: true },
        { title: 'Modalidad de Contratación', property: 'IDHiringModality', visible: true },
        { title: 'Fase de Preparación', property: 'PreparationState', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
        { title: 'Empleado', property: 'IDEmployee', visible: true },
    ];


    const agregarItem = () => {
        setBean({
            IDHiringModalityStage: IDHiringModalityStage,
            IDHiringModality: IDHiringModality,
            State: 1,
            IDEmployee: _single.getAccountID(),
        })
        modal.open("Agregar Relación de fase")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { agregarItem() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Relación ${bean.IDPreparationHiringStageMapping}`) } },
            { titulo: 'Eliminar', icono: 'ri-eraser-line', visible: _single.canDelete(), evento: () => { modalC.open("Eliminar Relación de Fase"); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {

        if (!validateForm()) {
            toast.error("Por favor complete los campos requeridos");
            return;
        }

        instance.updatePreparationHiringStageMapping(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} />


                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <p>Confirmar Eliminacion de {bean.IDPreparationHiringStageMapping}</p>
                </ModalConfirm>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${isMissing('PreparationState') ? 'has-error' : ''}`}>Fase de la necesidad {isRequired('PreparationState') ? <span className="text-danger">*</span> : ''}</label>
                            <SelectAdquisitionItemConstan label=" " idSelector={bean.PreparationState} onChange={(e) => { setBean({ ...bean, PreparationState: e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}